// EmptyUnit.js
import UnitBase from "./UnitBase";

class EmptyUnit extends UnitBase {
    constructor() {
        super(null, "", "");
    }
}

export default EmptyUnit;